module.exports = __webpack_public_path__ + "static/media/09_CALCINHA_DRAPEADA_LARGA_ESTAMPADA_04.38862292.jpg";